import { render, staticRenderFns } from "./EtapaResumo.vue?vue&type=template&id=c03dca34&scoped=true&lang=pug"
import script from "./EtapaResumo.vue?vue&type=script&lang=js"
export * from "./EtapaResumo.vue?vue&type=script&lang=js"
import style0 from "./EtapaResumo.vue?vue&type=style&index=0&id=c03dca34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03dca34",
  null
  
)

export default component.exports